import fs from "node:fs/promises"
import type { Config } from "tailwindcss"
// eslint-disable-next-line import/extensions
import resolveConfig from "tailwindcss/resolveConfig.js"
import type { PluginOption } from "vite"

function plugin(): PluginOption {
  const virtualModuleId = "virtual:tailwind.config"
  const resolvedVirtualModuleId = `\0${virtualModuleId}`

  return {
    name: "chartjs-plugin-tailwindcss-colors",

    // eslint-disable-next-line consistent-return, @typescript-eslint/explicit-function-return-type
    resolveId(id) {
      if (id === virtualModuleId) {
        return resolvedVirtualModuleId
      }
    },

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, consistent-return
    async load(id) {
      if (id === resolvedVirtualModuleId) {
        const file = await this.resolve("./tailwind.config")
        if (!file) {
          return this.error("Could not resolve TailwindCSS config file.")
        }

        try {
          // eslint-disable-next-line import/no-extraneous-dependencies
          const { transformWithEsbuild } = await import("vite")

          const contents = await fs.readFile(file.id, "utf8")
          const result = await transformWithEsbuild(contents, file.id)

          const encoded = Buffer.from(result.code).toString("base64")
          const url = `data:text/javascript;base64,${encoded}`
          const { default: config } = (await import(url)) as { default: Config }

          return `export default ${JSON.stringify({
            config,
            resolvedConfig: resolveConfig(config),
          })}`
        } catch (error) {
          // @ts-expect-error asfasf
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          this.error(new Error(error.message))
        }
      }
    },
  }
}

export default plugin
